/**
 * Created by dmitry on 19.08.2026
 */

BaseButtonBooster.prototype.onMouseOver = cleverapps.extendFunc(BaseButtonBooster.prototype.onMouseOver, function () {
    if (this.disabled) {
        return;
    }

    if (this.styles.hoverHighlight) {
        if (!this.hoverHighlight) {
            const styles = this.styles.hoverHighlight;
            const offset = styles.offset || { x: 0, y: 0 };

            this.hoverHighlight = new cc.Sprite(bundles.buttons.frames.booster_button_hover_png);
            this.hoverHighlight.setScale((styles.width || this.width) / this.hoverHighlight.width);
            this.hoverHighlight.setPosition(this.width / 2 + offset.x, this.height / 2 + offset.y);
            this.addChild(this.hoverHighlight, -1);
        }

        this.hoverHighlight.setVisible(true);
    }

    this._super();

    this.icon.setAnimationAndIdleAfter("activate", "active");
});

BaseButtonBooster.prototype.onMouseOut = cleverapps.extendFunc(BaseButtonBooster.prototype.onMouseOut, function () {
    if (this.hoverHighlight) {
        this.hoverHighlight.setVisible(false);
    }

    this._super();

    if (["idle", "deactivate"].includes(this.icon.getCurrentAnimationName())) {
        return;
    }

    this.icon.setAnimationAndIdleAfter("deactivate", "idle");
});

// the levitating icon is the hover feedback, so the button itself scales only while pressed
BaseButtonBooster.prototype._updateScale = function () {
    const baseScale = BaseScale(this);
    const scaleTo = PointerHandler.getState(this, "pressed") ? MaxInteractiveScale(this) : 1;

    this.setScale(baseScale.x * scaleTo, baseScale.y * scaleTo);
};

BaseButtonBooster.prototype.getContent = function (isOff = false) {
    const content = new cc.Node();
    content.setAnchorPoint(0.5, 0.5);
    const options = this.getLayoutOptions();

    const price = this[isOff ? "priceOff" : "price"] = this.getPriceText(isOff);
    price.setCascadeOpacityEnabled(true);

    const textNode = this[isOff ? "textNodeOff" : "textNode"] = new cc.Node();
    textNode.setAnchorPoint(0.5, 0.5);
    textNode.setContentSize(price.getContentSize());

    const amount = this[isOff ? "amountOff" : "amount"] = this.getAmountText(isOff);

    const ads = this[isOff ? "adsOff" : "ads"] = this.getAdsText(isOff);

    let icon = this[isOff ? "iconOff" : "icon"] = this.createIcon(isOff);

    [price, amount, ads].forEach((el) => {
        textNode.addChild(el);
        el.setAlignment({ align: "center" }, { align: "center" });
    });

    const iconSlotStyles = this.styles.content.iconSlot;

    if (iconSlotStyles) {
        const slot = new cc.Node();
        slot.setAnchorPoint(0.5, 0.5);
        slot.setContentSize2(iconSlotStyles.width, iconSlotStyles.height);
        slot.addChild(icon);
        icon.setPosition(slot.width / 2, slot.height / 2);
        icon = slot;
    }

    const layoutKey = isOff ? "layoutOff" : "layout";
    this[layoutKey] = new cleverapps.Layout([icon, textNode], options);
    content.addChild(this[layoutKey]);

    content.setAlignment({ x: { align: "center" }, y: { align: "center" } });
    this[layoutKey].setAlignment(this.styles.content.layout);

    return content;
};
